import { lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import I18njs from 'i18n-js';
import { useHistory } from 'react-router-dom';

import ErrorBoundary from '../../components/ErrorBoundary';
import DashboardContainer from '../DashboardContainer';
import PreviewComponent from './PreviewComponent';

import { loadingChunkRetry } from '../../helpers/utils';

const ApprovalsRouter = lazy(() => loadingChunkRetry(() => import('./ApprovalsRouter')));

export const ApprovalsContainer = ({ general }) => {
  const history = useHistory();

  if (!general.data.hasApproval && !general.data.loading && general.data.initialLoad) history.push('/not-found');

  return (
    <DashboardContainer showSecondaryNav>
      <Helmet>
        <title>{I18njs.t('helmet.Approvals')}</title>
      </Helmet>
      <ErrorBoundary>
        <Suspense fallback={<PreviewComponent />}>
          <ApprovalsRouter />
        </Suspense>
      </ErrorBoundary>
    </DashboardContainer>
  );
};

const mapStateToProps = (state) => ({
  general: state.general,
});

export default connect(mapStateToProps, null)(ApprovalsContainer);
